import { Controller } from "@hotwired/stimulus"

// Reusable GTM dataLayer push controller.
//
// Page-load event (fires on connect):
//   data-controller="gtm"
//   data-gtm-event-value='{"event":"step_view","step_name":"create_pitch","step_number":1}'
//
// Click event (fires on action):
//   data-action="click->gtm#push"
//   data-gtm-payload-param='{"event":"start_click","cta_name":"lets_get_started","location":"homepage"}'
//
// Click/submit event with dynamic DOM values merged in:
//   data-action="submit->gtm#pushWithDom"
//   data-gtm-payload-param='{"event":"buy_now_pricing_click","plan_type":"pay_per_use","currency":"EUR"}'
//   data-gtm-dom-values-param='{"quantity":"#oneoff-count","value":"#oneoff-price"}'
//
// Disable auto-fire on connect:
//   data-gtm-fire-on-connect-value="false"
//
export default class extends Controller {
  static values = {
    event: { type: Object, default: {} },
    fireOnConnect: { type: Boolean, default: true }
  }

  connect() {
    if (this.fireOnConnectValue && this.hasEventValue && Object.keys(this.eventValue).length > 0) {
      this.#push(this.eventValue)
    }
  }

  push(e) {
    const payload = e.params.payload
    if (payload) {
      this.#push(payload)
    }
  }

  pushWithDom(e) {
    const payload = { ...(e.params.payload || {}) }
    const domValues = e.params.domValues
    if (domValues) {
      for (const [key, selector] of Object.entries(domValues)) {
        const el = document.querySelector(selector)
        if (el) {
          const num = parseInt(el.textContent.trim(), 10)
          payload[key] = isNaN(num) ? el.textContent.trim() : num
        }
      }
    }
    this.#push(payload)
  }

  #push(data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }
}
